import { all } from "redux-saga/effects";

import {
  stockAuditCreateWatcher,
  stockAuditEditWatcher,
  stockAuditLoadFiltersWatcher,
  stockAuditTableWatcher,
  stockAuditViewWatcher,
  stockDetailsBatchDropDownWatcher,
  stockDetailsBatchUpdateWatcher,
  stockDetailsBatchViewWatcher,
  stockDetailsItemViewWatcher,
  stockDetailsItemsFetchWatcher,
} from "../stock-details-saga";

export default function* stockAuditRootSaga() {
  yield all([
    stockDetailsItemsFetchWatcher(),
    stockDetailsBatchViewWatcher(),
    stockDetailsBatchDropDownWatcher(),
    stockDetailsBatchUpdateWatcher(),
    stockDetailsItemViewWatcher(),
    stockAuditTableWatcher(),
    stockAuditLoadFiltersWatcher(),
    stockAuditCreateWatcher(),
    stockAuditViewWatcher(),
    stockAuditEditWatcher(),
  ]);
}
